import { Injectable, WritableSignal } from "@angular/core";
import { ErrorImmutable } from "../obj/ErrorImmutable";


@Injectable({
    providedIn: "root"
})
export class ValidationService {

    private data = {
        "Account": {
            "serviceName": {
                "min": 2,
                "max": 50
            },
            "address": {
                "min": 10,
                "max": 100
            },
            "city": {
                "min": 2,
                "max": 50
            },
            "zip": {
                "min": 5,
                "max": 5
            },
            "keyName": {
                "min": 1,
                "max": 4
            }
        },
        "ExistingContract": {
            "supplierName": {
                "min": 2,
                "max": 50
            }
        },
        "User": {
            "firstName": {
                "min": 2,
                "max": 50
            },
            "lastName": {
                "min": 2,
                "max": 50
            },
            "jobTitle": {
                "min": 2,
                "max": 20
            },
            "email": {
                "min": 4,
                "max": 320
            },
            "phone": {
                "min": 5,
                "max": 20
            },
            "password": {
                "min": 8,
                "max": 20
            },
            "address": {
                "min": 10,
                "max": 100
            },
            "city": {
                "min": 2,
                "max": 50
            },
            "zip": {
                "min": 3,
                "max": 5
            }
        },
        "Company": {
            "name": {
                "min": 2,
                "max": 50
            },
            "website": {
                "min": 2,
                "max": 2048
            },
            "federalTaxID": {
                "min": 2,
                "max": 20
            },
            "city": {
                "min": 2,
                "max": 100
            },
            "addressLine1": {
                "min": 5,
                "max": 100
            },
            "addressLine2": {
                "min": 5,
                "max": 100
            },
            "zip": {
                "min": 5,
                "max": 10
            },
            "phone": {
                "min": 5,
                "max": 20
            },
            "enrollEmail": {
                "min": 5,
                "max": 254
            },
            "enrollCCEmail": {
                "min": 5,
                "max": 254
            }
        },
    };

    constructor() {
    }

    getMinLength(objName: string, fieldName: string): number | null {
        var objInfo = this.data[objName as keyof typeof this.data];
        if (objInfo == null) {
            return null;
        }
        var fieldInfo = objInfo[fieldName as keyof typeof objInfo];
        if (fieldInfo == null) {
            return null;
        }
        return fieldInfo["min"];
    }

    getMaxLength(objName: string, fieldName: string): number | null {
        var objInfo = this.data[objName as keyof typeof this.data];
        if (objInfo == null) {
            return null;
        }
        var fieldInfo = objInfo[fieldName as keyof typeof objInfo];
        if (fieldInfo == null) {
            return null;
        }
        return fieldInfo["max"];
    }

    validate(objName: string, fieldName: string, value: string | null, error: WritableSignal<ErrorImmutable>, fieldNameForError: string | null = null): boolean {
        if (fieldNameForError == null) {
            fieldNameForError = fieldName;
        }
        if (value == null || (this.getMinLength(objName, fieldName) != null && value.length < this.getAsNumber(this.getMinLength(objName, fieldName)))) {
            error.set(error().addToErrors(fieldNameForError));
            error.set(error().setError("The minimal length of the field is: " + this.getAsNumber(this.getMinLength(objName, fieldName)) + " characters."));
            return false;
        }
        if (this.getMaxLength(objName, fieldName) != null && value.length > this.getAsNumber(this.getMaxLength(objName, fieldName))) {
            error.set(error().addToErrors(fieldNameForError));
            error.set(error().setError("The maximal length of the field is: " + this.getAsNumber(this.getMaxLength(objName, fieldName)) + " characters."));
            return false;
        }
        return true;
    }

    getAsNumber(num: number | null): number {
        if (num == null) {
            return 0;
        }
        return num;
    }

}